var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchWithNetworkCache } from "../../cache/network";
// Some of the CimDocs refer to projections that don't work with CORS.
// For this reason, we use a proxy server to get at them instead.
function transformProjectionUrl(url) {
    return `https://proxy.fusion.documents.cimpress.io/proxy?sourceUrl=${encodeURIComponent(url)}`;
}
export function getProjectionSpecification(projectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = transformProjectionUrl(projectionId);
        return fetchWithNetworkCache({
            url,
            responseResolver: (response) => __awaiter(this, void 0, void 0, function* () {
                return (yield response.json());
            }),
        });
    });
}
//# sourceMappingURL=projectionClient.js.map